__turbopack_context__.v({
  "content": "ProfileNotice-module-scss-module__lppvpG__content",
  "root": "ProfileNotice-module-scss-module__lppvpG__root",
});
